import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_input = _resolveComponent("select-input")!

  return (_openBlock(), _createBlock(_component_select_input, _mergeProps(_ctx.$attrs, {
    tclass: _ctx.tclass,
    label: _ctx.label,
    items: _ctx.items,
    name: _ctx.name
  }), null, 16, ["tclass", "label", "items", "name"]))
}